import { createRequiredValidators } from "@xo/client-common";
import { Type5Boolean } from "./Type5Boolean";

export function createType5BooleanValidators() {
    return [
        ...createRequiredValidators<Type5Boolean>(["arrayField", "valueListArray", "validatedArrayField"]),
    ];
}
